export default __webpack_public_path__ + "static/media/tour3.7b5f0420.webp";